/* eslint-disable @typescript-eslint/no-unused-vars */
import Grid from '@material-ui/core/Grid'
import Moment from 'moment'
import MomentJalaali from 'moment-jalaali'
import React from 'react'

import { getTimeView } from '../../../../helpers/date'
import { CustomMonthViewProps } from '../types/DateRangePicker.types'
import WeekDayNamesView from './WeekDayNamesView'
import useStyles from './styles/monthView.style'

const CustomMonthView: React.FC<CustomMonthViewProps> = (props) => {
  const classes = useStyles()
  const {
    data = [],
    name,
    currentMonth,
    currentYear,
    currentMonthFirstDay,
    selectedStartDate,
    selectedEndDate,
    hoveredDate,
    selectFromPast,
    selectAllDays,
    onSelectStartDate,
    onSelectEndDate,
    onHoverDate,
    lastSelectedDateRangeType,
    type,
    showJalaaliHolidays,
    range,
    multipleDates,
    selectedDatesList,
    numberOfVisibleMonths,
    todayDay,
    endDateCanBeSelectAsStartDate,
    disableBefore,
    disableAfter
  } = props

  const startDateIsFromCurrentMonth =
    selectedStartDate && currentMonth === selectedStartDate.split('-')[1]

  const endDateIsFromCurrentMonth =
    selectedEndDate && currentMonth === selectedEndDate.split('-')[1]

  const hoveredDateIsFromCurrentMonth =
    hoveredDate && currentMonth === hoveredDate.split('-')[1]

  const selectedStartDateDay = selectedStartDate
    ? parseInt(selectedStartDate.split('-')[2], 10)
    : 0

  const selectedEndDateDay = selectedEndDate
    ? parseInt(selectedEndDate.split('-')[2], 10)
    : 0

  // const hoveredDateIsFromNextMonths =
  //   hoveredDate && hoveredDate.split('-')[0] === currentYear
  //     ? hoveredDate.split('-')[1] > currentMonth
  //     : hoveredDate && hoveredDate.split('-')[0] > currentYear
  //     ? (Number(hoveredDate.split('-')[1]) + 12).toString() > currentMonth
  //     : ''
  const hoveredDateIsFromNextMonths = hoveredDate
    ? hoveredDate.split('-')[1] > currentMonth
    : ''

  // const endDateIsFromNextMonths =
  //   selectedEndDate && selectedEndDate.split('-')[0] === currentYear
  //     ? selectedEndDate.split('-')[1] > currentMonth
  //     : selectedEndDate && selectedEndDate.split('-')[0] > currentYear
  //     ? (Number(selectedEndDate.split('-')[1]) + 12).toString() > currentMonth
  //     : ''
  const endDateIsFromNextMonths = selectedEndDate
    ? selectedEndDate.split('-')[1] > currentMonth
    : ''

  const startDateIsFromPreviousMonths = selectedStartDate
    ? selectedStartDate.split('-')[1] < currentMonth
    : ''

  const hoveredDateDay = hoveredDate
    ? parseInt(hoveredDate.split('-')[2], 10)
    : 0

  const startOfMonth =
    type === 'jalaali'
      ? MomentJalaali().startOf('jMonth')
      : Moment().startOf('month')

  // eslint-disable-next-line no-nested-ternary
  const currentMonthIsBeforeTodayMonth = selectAllDays
    ? false
    : selectFromPast
    ? currentMonthFirstDay >
      startOfMonth.clone().format(getTimeView(type).basicView)
    : currentMonthFirstDay <
      startOfMonth.clone().format(getTimeView(type).basicView)

  const todayIsInCurrentMonth =
    currentMonthFirstDay ===
    startOfMonth.clone().format(getTimeView(type).basicView)

  const monthIsBetweenStartDateEndDateOrStartDateHoverDate =
    (startDateIsFromPreviousMonths && endDateIsFromNextMonths) ||
    (startDateIsFromPreviousMonths && hoveredDateIsFromNextMonths)

  const onClickDate = (selectedDay: number) => {
    const selectedDate = `${currentYear}-${currentMonth}-${
      selectedDay < 10 ? '0' : ''
    }${selectedDay}`
    if (selectedDay) {
      if (
        selectedStartDate &&
        selectedDate >= selectedStartDate &&
        lastSelectedDateRangeType === 'START_DATE' &&
        range
      ) {
        onSelectEndDate(selectedDay)
      } else {
        onSelectStartDate(selectedDay)
      }
    }
  }

  const onHoveredDate = (newHoveredDate: number) => {
    if (newHoveredDate) {
      onHoverDate(newHoveredDate)
    }
  }

  const disableBeforeDateObj = disableBefore
    ? new Date(
        new Date(disableBefore).getFullYear(),
        new Date(disableBefore).getMonth(),
        new Date(disableBefore).getDate()
      ) // ✅ Force local midnight
    : null

  const disableAfterDateObj = disableAfter
    ? new Date(
        new Date(disableAfter).getFullYear(),
        new Date(disableAfter).getMonth(),
        new Date(disableAfter).getDate()
      ) // ✅ Force local midnight
    : null

  return (
    <Grid className={classes.rootGrid}>
      <Grid container direction="column">
        <Grid item className={classes.monthContainer}>
          <span className={classes.monthName}>{name}</span>
          &nbsp;
          <span className={classes.monthName}>{currentYear}</span>
        </Grid>
        <Grid item className={classes.weekDayNamesGridItem}>
          <WeekDayNamesView type={type} />
        </Grid>
        <Grid item>
          <Grid container className={classes.monthContainer}>
            {(currentMonthIsBeforeTodayMonth &&
              data.map((singleDay, index) => {
                return (
                  <span
                    key={name + index.toString()}
                    className={[
                      classes.dayDefaultStyle,
                      singleDay ? classes.validDayDefaultStyle : '',
                      (!startDateIsFromCurrentMonth &&
                        !endDateIsFromCurrentMonth &&
                        monthIsBetweenStartDateEndDateOrStartDateHoverDate &&
                        singleDay &&
                        range) ||
                      (singleDay > selectedStartDateDay &&
                        startDateIsFromCurrentMonth)
                        ? classes.inBetweenDays
                        : (!startDateIsFromCurrentMonth &&
                            !endDateIsFromCurrentMonth &&
                            monthIsBetweenStartDateEndDateOrStartDateHoverDate &&
                            singleDay &&
                            range) ||
                          (singleDay >= selectedStartDateDay &&
                            startDateIsFromCurrentMonth)
                        ? classes.selectedStartDate
                        : '',
                      classes.disabledDay
                    ].join(' ')}
                    data-cy={classes.disabledDay ? 'disableData_cy' : null}>
                    {singleDay}
                  </span>
                )
              })) ||
              (startDateIsFromCurrentMonth &&
                endDateIsFromCurrentMonth &&
                data.map((singleDay, index) => {
                  const today = singleDay

                  const todayDateObj = new Date(currentMonthFirstDay)
                  return (
                    <span
                      key={name + index.toString()}
                      className={[
                        classes.dayDefaultStyle,
                        todayIsInCurrentMonth && today === todayDay
                          ? classes.addBorderBottomToToday
                          : singleDay &&
                            !(
                              today > selectedStartDateDay &&
                              today < selectedEndDateDay &&
                              range
                            )
                          ? classes.validDayDefaultStyle
                          : '',
                        selectedStartDateDay === today ||
                        (range && selectedDatesList?.includes(today))
                          ? classes.selectedStartDate
                          : '',
                        selectedEndDateDay === today
                          ? classes.selectedEndDate
                          : '',
                        endDateCanBeSelectAsStartDate &&
                        selectedEndDate === selectedStartDate
                          ? classes.selectedEndDateAsStartDate
                          : '',
                        singleDay &&
                        today > selectedStartDateDay &&
                        today < selectedEndDateDay &&
                        range
                          ? classes.inBetweenDays
                          : '',
                        todayIsInCurrentMonth &&
                        !selectAllDays &&
                        ((selectFromPast && today > todayDay) ||
                          (!selectFromPast && today < todayDay))
                          ? classes.disabledDay
                          : '',
                        (disableBeforeDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) < disableBeforeDateObj) ||
                        (disableAfterDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) > disableAfterDateObj)
                          ? classes.disabledDay
                          : ''
                      ].join(' ')}
                      onClick={() => {
                        if (
                          !(
                            (todayIsInCurrentMonth &&
                              !selectAllDays &&
                              ((selectFromPast && today > todayDay) ||
                                (!selectFromPast && today < todayDay))) ||
                            (disableBeforeDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) < disableBeforeDateObj) ||
                            (disableAfterDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) > disableAfterDateObj)
                          )
                        ) {
                          onClickDate(singleDay)
                        }
                      }}
                      onMouseEnter={() => onHoveredDate(singleDay)}>
                      {singleDay}
                    </span>
                  )
                })) ||
              (startDateIsFromCurrentMonth &&
                !endDateIsFromCurrentMonth &&
                data.map((singleDay, index) => {
                  const today = singleDay

                  const todayDateObj = new Date(currentMonthFirstDay)
                  return (
                    <span
                      key={name + index.toString()}
                      className={[
                        classes.dayDefaultStyle,
                        todayIsInCurrentMonth && today === todayDay
                          ? classes.addBorderBottomToToday
                          : singleDay &&
                            !(
                              today > selectedStartDateDay &&
                              (hoveredDateIsFromNextMonths ||
                                today < hoveredDateDay ||
                                endDateIsFromNextMonths) &&
                              range
                            )
                          ? classes.validDayDefaultStyle
                          : '',
                        (selectedStartDateDay === today ||
                          (range && selectedDatesList?.includes(today))) &&
                        !range
                          ? classes.selectedStartDateForNonRange
                          : selectedStartDateDay === today ||
                            (range && selectedDatesList?.includes(today))
                          ? classes.selectedStartDate
                          : '',
                        singleDay &&
                        today > selectedStartDateDay &&
                        (hoveredDateIsFromNextMonths ||
                          today < hoveredDateDay ||
                          endDateIsFromNextMonths) &&
                        range
                          ? classes.inBetweenDays
                          : '',
                        todayIsInCurrentMonth &&
                        !selectAllDays &&
                        ((selectFromPast && today > todayDay) ||
                          (!selectFromPast && today < todayDay))
                          ? classes.disabledDay
                          : '',
                        (disableBeforeDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) < disableBeforeDateObj) ||
                        (disableAfterDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) > disableAfterDateObj)
                          ? classes.disabledDay
                          : ''
                      ].join(' ')}
                      onClick={() => {
                        if (
                          !(
                            (todayIsInCurrentMonth &&
                              !selectAllDays &&
                              ((selectFromPast && today > todayDay) ||
                                (!selectFromPast && today < todayDay))) ||
                            (disableBeforeDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) < disableBeforeDateObj) ||
                            (disableAfterDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) > disableAfterDateObj)
                          )
                        ) {
                          onClickDate(singleDay)
                        }
                      }}
                      onMouseEnter={() => onHoveredDate(singleDay)}>
                      {singleDay}
                    </span>
                  )
                })) ||
              (!startDateIsFromCurrentMonth &&
                endDateIsFromCurrentMonth &&
                data.map((singleDay, index) => {
                  const today = singleDay
                  const todayDateObj = new Date(currentMonthFirstDay)

                  return (
                    <span
                      key={name + index.toString()}
                      className={[
                        classes.dayDefaultStyle,
                        todayIsInCurrentMonth && today === todayDay
                          ? classes.addBorderBottomToToday
                          : singleDay && !(today < selectedEndDateDay && range)
                          ? classes.validDayDefaultStyle
                          : '',
                        selectedEndDateDay === today
                          ? classes.selectedEndDate
                          : '',
                        endDateCanBeSelectAsStartDate &&
                        selectedEndDate === selectedStartDate
                          ? classes.selectedEndDateAsStartDate
                          : '',
                        singleDay && today < selectedEndDateDay && range
                          ? classes.inBetweenDays
                          : '',
                        (disableBeforeDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            singleDay
                          ) < disableBeforeDateObj) ||
                        (disableAfterDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            singleDay
                          ) > disableAfterDateObj)
                          ? classes.disabledDay
                          : ''
                      ].join(' ')}
                      onClick={() => onClickDate(singleDay)}
                      onMouseEnter={() => onHoveredDate(singleDay)}>
                      {singleDay}
                    </span>
                  )
                })) ||
              (!startDateIsFromCurrentMonth &&
                !endDateIsFromCurrentMonth &&
                startDateIsFromPreviousMonths &&
                hoveredDateIsFromCurrentMonth &&
                !monthIsBetweenStartDateEndDateOrStartDateHoverDate &&
                (!selectedStartDate || !selectedEndDate) &&
                data.map((singleDay, index) => {
                  const today = singleDay
                  const todayDateObj = new Date(currentMonthFirstDay)

                  return (
                    <span
                      key={name + index.toString()}
                      className={[
                        classes.dayDefaultStyle,
                        todayIsInCurrentMonth && today === todayDay
                          ? classes.addBorderBottomToToday
                          : singleDay && !(today < hoveredDateDay && range)
                          ? classes.validDayDefaultStyle
                          : '',
                        singleDay && today < hoveredDateDay && range
                          ? classes.inBetweenDays
                          : '',
                        todayIsInCurrentMonth &&
                        !selectAllDays &&
                        ((selectFromPast && today > todayDay) ||
                          (!selectFromPast && today < todayDay))
                          ? classes.disabledDay
                          : '',
                        (disableBeforeDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) < disableBeforeDateObj) ||
                        (disableAfterDateObj &&
                          new Date(
                            todayDateObj.getFullYear(),
                            todayDateObj.getMonth(),
                            today
                          ) > disableAfterDateObj)
                          ? classes.disabledDay
                          : ''
                      ].join(' ')}
                      onClick={() => {
                        if (
                          !(
                            (todayIsInCurrentMonth &&
                              !selectAllDays &&
                              ((selectFromPast && today > todayDay) ||
                                (!selectFromPast && today < todayDay))) ||
                            (disableBeforeDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) < disableBeforeDateObj) ||
                            (disableAfterDateObj &&
                              new Date(
                                todayDateObj.getFullYear(),
                                todayDateObj.getMonth(),
                                today
                              ) > disableAfterDateObj)
                          )
                        ) {
                          onClickDate(singleDay)
                        }
                      }}
                      onMouseEnter={() => onHoveredDate(singleDay)}>
                      {singleDay}
                    </span>
                  )
                })) ||
              (!startDateIsFromCurrentMonth &&
                !endDateIsFromCurrentMonth &&
                monthIsBetweenStartDateEndDateOrStartDateHoverDate &&
                data.map((singleDay, index) => (
                  <span
                    key={name + index.toString()}
                    className={[
                      classes.dayDefaultStyle,
                      singleDay && !range ? classes.validDayDefaultStyle : '',
                      todayIsInCurrentMonth && todayDay > singleDay
                        ? classes.disabledDay
                        : '',
                      singleDay && range ? classes.inBetweenDays : ''
                    ].join(' ')}
                    onClick={() => onClickDate(singleDay)}
                    onMouseEnter={() => onHoveredDate(singleDay)}>
                    {singleDay}
                  </span>
                ))) ||
              data.map((singleDay, index) => {
                const today = singleDay
                const todayDateObj = new Date(currentMonthFirstDay)

                return (
                  <span
                    key={name + index.toString()}
                    className={[
                      classes.dayDefaultStyle,
                      todayIsInCurrentMonth && today === todayDay
                        ? classes.addBorderBottomToToday
                        : singleDay
                        ? classes.validDayDefaultStyle
                        : '',
                      todayIsInCurrentMonth &&
                      !selectAllDays &&
                      ((selectFromPast && today > todayDay) ||
                        (!selectFromPast && today < todayDay))
                        ? classes.disabledDay
                        : '',
                      (disableBeforeDateObj &&
                        new Date(
                          todayDateObj.getFullYear(),
                          todayDateObj.getMonth(),
                          today
                        ) < disableBeforeDateObj) ||
                      (disableAfterDateObj &&
                        new Date(
                          todayDateObj.getFullYear(),
                          todayDateObj.getMonth(),
                          today
                        ) > disableAfterDateObj)
                        ? classes.disabledDay
                        : ''
                    ].join(' ')}
                    onClick={() => {
                      if (
                        !(
                          (todayIsInCurrentMonth &&
                            !selectAllDays &&
                            ((selectFromPast && today > todayDay) ||
                              (!selectFromPast && today < todayDay))) ||
                          (disableBeforeDateObj &&
                            new Date(
                              todayDateObj.getFullYear(),
                              todayDateObj.getMonth(),
                              today
                            ) < disableBeforeDateObj) ||
                          (disableAfterDateObj &&
                            new Date(
                              todayDateObj.getFullYear(),
                              todayDateObj.getMonth(),
                              today
                            ) > disableAfterDateObj)
                        )
                      ) {
                        onClickDate(singleDay)
                      }
                    }}
                    onMouseEnter={() => onHoveredDate(singleDay)}>
                    {singleDay}
                  </span>
                )
              })}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default CustomMonthView
